import { rankWith, isDateControl } from '@jsonforms/core';

export default rankWith(100, isDateControl);
